import React from 'react';
import PropTypes from 'prop-types';
import SaleIcon from '../SaleIcon/SaleIcon';
import NewIcon from '../../icons/icon-new-badge.svg';
import FreeGiftIcon from '../../icons/icon-free-gift.svg';


const ProductBadge = function ProductBadgeComponent({ attributes, promotions, className }) {
  const hasFreeGift = promotions && promotions.length > 0 &&
    promotions.filter(promotion => promotion.type === 'gift').length > 0;

  if (attributes.onSale) {
    return <SaleIcon className={className} display={attributes.onSale} />;
  }
  if (hasFreeGift) {
    return <FreeGiftIcon className={`${className} ${className}--promotion`} />;
  }
  if (attributes.newProduct) {
    return <NewIcon className={`${className} ${className}--new`} />;
  }

  return null;
};

ProductBadge.propTypes = {
  attributes: PropTypes.shape({
    newProduct: PropTypes.bool,
    onSale: PropTypes.bool,
  }),
  className: PropTypes.string,
  promotions: PropTypes.arrayOf(PropTypes.shape({})),
};
ProductBadge.defaultProps = {
  attributes: {},
  className: 'product_badge',
  promotions: [],
};

export default ProductBadge;
